import { render, staticRenderFns } from "./AccountHolderExpensePayee.vue?vue&type=template&id=a6c398d4&scoped=true"
import script from "./AccountHolderExpensePayee.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpensePayee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c398d4",
  null
  
)

export default component.exports